import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home py-10" }
const _hoisted_2 = { class: "home__block" }
const _hoisted_3 = { class: "home__block" }

import HomeForm from "@/components/home/HomeForm.vue";
import HomeInfo from "@/components/home/HomeInfo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HomeInfo)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(HomeForm)
    ])
  ]))
}
}

})